import { Toast } from 'materialize-css';
import endpoints from '../endpoints.ts';
import { SoPFile } from '../types/models.ts';
import { fetch } from './helpers.ts';

const illegitReport = {
  create: {},
  read: {
    many: {
      sopAttachments: {
        by: {
          customerId: async (): Promise<SoPFile[] | null> => {
            const url = endpoints.file.read.many.sopAttachments.by.customerId();
            return await fetch<SoPFile[]>(url, 'GET');
          },
        },
      },
    },
  },
  update: {},
  delete: {
    one: {
      sopAttachment: {
        by: {
          id: async (
            sopAttachmentId: string,
            signal?: AbortSignal
          ): Promise<Buffer | null> => {
            const url = endpoints.file.delete.one.sopAttachment.by.id();
            return await fetch<Buffer | null>(
              url,
              'DELETE',
              { sopAttachmentId },
              { signal }
            );
          },
        },
      },
    },
  },
  download: {
    sop: async (data: { sopAttachmentId: string }): Promise<Buffer | null> => {
      const url = endpoints.file.download.sop();
      return await fetch<Buffer | null>(url, 'GET', data, {
        responseType: 'arraybuffer',
      });
    },
    sopAttachment: {
      by: {
        id: async (id: number): Promise<Buffer | null> => {
          const url = endpoints.file.download.sopAttachment.by.id();
          return await fetch<Buffer | null>(
            url,
            'GET',
            { sopAttachmentId: id },
            {
              responseType: 'arraybuffer',
            }
          );
        },
      },
    },
  },
  upload: {
    many: {
      sop: async (
        formData: FormData,
        signal?: AbortSignal
      ): Promise<Toast | null> => {
        const url = endpoints.file.upload.many.sop();
        return await fetch<Toast | null>(url, 'POST', formData, {
          signal,
        });
      },
    },
    sop: async (
      formData: FormData,
      signal?: AbortSignal
    ): Promise<Toast | null> => {
      const url = endpoints.file.upload.sop();
      return await fetch<Toast | null>(url, 'POST', formData, {
        signal,
      });
    },
  },
};

export default illegitReport;
